import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '@tempmee/react';
import { getPromoCodeStatusSeverity } from '../../../../domain/Campaigns';

/**
 * The ticket's date-derived code status as a design-system `Label`. One
 * component so the list, the detail heading and the office tab cannot drift
 * into showing the same status in different colours.
 */
export const PromoCodeStatusLabel = ({ status, label }) => (
  <Label severity={getPromoCodeStatusSeverity(status)} variant="standard">
    {label}
  </Label>
);

PromoCodeStatusLabel.propTypes = {
  /** The derived status key — pending, active, paused or expired. */
  status: PropTypes.string.isRequired,
  /** Its display label. */
  label: PropTypes.string.isRequired,
};

export default PromoCodeStatusLabel;
